module.exports = __webpack_public_path__ + "static/img/digitalize.1593a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortalPhone/digitalize.png
// module id = rHtL
// module chunks = 0